<template>
  <v-row class="pa-0" dense>
    <!-- Data Inicial -->
    <v-col cols="12" md="6" class="pr-0 pr-md-3">
      <v-menu v-model="menuInicio" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dataInicio"
            :label="labelInicio"
            append-icon="mdi-calendar"
            readonly
            :dense="dense"
            outlined
            :rules="regrasObrigatorias"
            v-bind="attrs"
            :error="!!erroInicio"
            :error-messages="erroInicio"
            v-on="on"
          />
        </template>

        <v-date-picker
          v-model="pickerInicio"
          :max="maxInicio"
          :min="minInicio"
          scrollable
          locale="pt-br"
          @input="selecionarDataInicio"
        />
      </v-menu>
    </v-col>

    <!-- Data Final -->
    <v-col cols="12" md="6" class="pl-0 pl-md-3">
      <v-menu v-model="menuFim" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dataFim"
            :label="labelFim"
            append-icon="mdi-calendar"
            readonly
            :dense="dense"
            outlined
            :rules="regrasObrigatorias"
            v-bind="attrs"
            :error="!!erroFim"
            :error-messages="erroFim"
            v-on="on"
          />
        </template>

        <v-date-picker v-model="pickerFim" :min="minFim" scrollable locale="pt-br" @input="selecionarDataFim" />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'PeriodoData',
    props: {
      inicio: {
        type: String,
        default: null // formato DD/MM/AAAA
      },
      fim: {
        type: String,
        default: null
      },
      labelInicio: {
        type: String,
        default: 'Data inicial'
      },
      labelFim: {
        type: String,
        default: 'Data final'
      },
      dense: {
        type: Boolean,
        default: true
      },
      obrigatorio: {
        type: Boolean,
        default: false
      },
      inicioAPartirDeHoje: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dataInicio: this.inicio,
        dataFim: this.fim,
        pickerInicio: this.inicio ? this.stringParaIso(this.inicio) : null,
        pickerFim: this.fim ? this.stringParaIso(this.fim) : null,
        menuInicio: false,
        menuFim: false,
        erroInicio: '',
        erroFim: ''
      };
    },
    computed: {
      regrasObrigatorias() {
        return this.obrigatorio ? [this.regraObrigatoria] : [];
      },
      hojeIso() {
        if (!this.inicioAPartirDeHoje) return null;

        const hoje = new Date();
        const mes = String(hoje.getMonth() + 1).padStart(2, '0');
        const dia = String(hoje.getDate()).padStart(2, '0');

        return `${hoje.getFullYear()}-${mes}-${dia}`;
      },
      minInicio() {
        return this.hojeIso || undefined;
      },
      maxInicio() {
        if (!this.pickerFim) return undefined;
        if (this.hojeIso && this.pickerFim < this.hojeIso) return undefined;

        return this.pickerFim;
      },
      minFim() {
        if (this.pickerInicio) return this.pickerInicio;

        return this.hojeIso || undefined;
      }
    },
    methods: {
      regraObrigatoria(valor) {
        return !!valor || 'Campo obrigatório.';
      },
      stringParaIso(str) {
        if (!str) return null;
        const [dia, mes, ano] = str.split('/').map(Number);
        return `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
      },
      isoParaString(iso) {
        if (!iso) return null;
        const [ano, mes, dia] = iso.split('-');
        return `${dia}/${mes}/${ano}`;
      },
      selecionarDataInicio(valor) {
        this.menuInicio = false;
        this.dataInicio = this.isoParaString(valor);
        this.pickerInicio = valor;
        this.emitirDatas();
      },
      selecionarDataFim(valor) {
        this.menuFim = false;
        this.dataFim = this.isoParaString(valor);
        this.pickerFim = valor;
        this.emitirDatas();
      },
      emitirDatas() {
        this.validarDatas();
        if (!this.erroInicio && !this.erroFim) {
          this.$emit('update:inicio', this.dataInicio || null);
          this.$emit('update:fim', this.dataFim || null);
          this.$emit('update:periodo', { dataInicio: this.dataInicio || null, dataFim: this.dataFim || null });
        }
      },
      validarDatas() {
        this.erroInicio = '';
        this.erroFim = '';

        const inicioIso = this.dataInicio ? this.stringParaIso(this.dataInicio) : null;
        const fimIso = this.dataFim ? this.stringParaIso(this.dataFim) : null;

        if (this.hojeIso && inicioIso && inicioIso < this.hojeIso) {
          this.erroInicio = 'Data inicial não pode ser anterior a hoje';
        }

        if (inicioIso && fimIso && inicioIso > fimIso) {
          this.erroInicio = this.erroInicio || 'Data inicial não pode ser maior que a final';
          this.erroFim = 'Data final não pode ser menor que a inicial';
        }
      }
    },
    watch: {
      inicio(novo) {
        this.dataInicio = novo;
        this.pickerInicio = novo ? this.stringParaIso(novo) : null;
      },
      fim(novo) {
        this.dataFim = novo;
        this.pickerFim = novo ? this.stringParaIso(novo) : null;
      }
    }
  };
</script>
